import { createContext } from "react";

export const ClientContext = createContext(
    {
        dbId: "",
        dbName: "",
        hostName: "",
        routesData:[],
    });